export default {"src":"/_next/static/media/top.843e0fc6.svg","height":155,"width":326};